import { render } from "./SistemaMarcaRewardNew.vue?vue&type=template&id=4e31c7b8&scoped=true"
import script from "./SistemaMarcaRewardNew.vue?vue&type=script&lang=js"
export * from "./SistemaMarcaRewardNew.vue?vue&type=script&lang=js"

import "./SistemaMarcaRewardNew.vue?vue&type=style&index=0&id=4e31c7b8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e31c7b8"]])

export default __exports__